import { Controller } from "react-hook-form";
import { BaseField } from "./BaseField";
import { FieldProps } from "modules/record/record-producer/types/record-producer-types";
import { RichHtmlFieldInput } from "modules/record/shared/fields/RichHtmlFieldInput";
import { buildRequiredRule, getRequiredFieldMessage } from "../../services/recordProducerValidation";
import { getFieldHelperText } from "../../services/fieldHelperText";

export const RichHtmlFieldComponent = ({ column, control, baseFieldProps, runtimeProps }: FieldProps) => (
    <BaseField column={column} required={runtimeProps?.required} hidden={runtimeProps?.hidden} {...baseFieldProps} as="group">
        {(headerId) => (
            <Controller
                name={column.name}
                control={control}
                defaultValue={column.default_value || ""}
                rules={{ required: buildRequiredRule(runtimeProps?.required ?? column.is_mandatory, getRequiredFieldMessage(column)) }}
                render={({ field, fieldState }) => (
                    <RichHtmlFieldInput
                        ariaLabelledBy={headerId}
                        value={field.value ?? ""}
                        onChange={field.onChange}
                        disabled={runtimeProps?.readonly}
                        error={!!fieldState.error}
                        helperText={getFieldHelperText(fieldState, runtimeProps)}
                    />
                )}
            />
        )}
    </BaseField>
);
